<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-toggle-switch-docs-preview></ui-toggle-switch-docs-preview></p>
<h1 id="description">Description</h1>
<p>Default toogle.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html">    <span class="hljs-tag">&lt;<span class="hljs-name">ui-toggle-switch</span> [<span class="hljs-attr">isChecked</span>]=<span class="hljs-string">"switchEnabled"</span> [<span class="hljs-attr">disabled</span>]=<span class="hljs-string">"multiClickProtected"</span> 
    (<span class="hljs-attr">switchChange</span>)=<span class="hljs-string">"onToggleChanges($event)"</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">ui-toggle-switch</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">interim</td>
<td align="left">If the interim state should be shown</td>
</tr>
<tr>
<td align="left">label</td>
<td align="left">Label of the checkbox</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
